module.exports = __webpack_public_path__ + "img/1528079938.da5a9443.jpg";